export enum VisibilityStatus {
    PRIVATE = 'PRIVATE', PUBLIC = 'PUBLIC'
}
